var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C68F3",
    fillRule: "evenodd",
    d: "M18.428 9.428v3.429H7.253c.488 2.24 2.433 3.857 4.747 3.857c1.913 0 3.628-1.338 4.42-3h2.008V17.1c0 .734-.575 1.328-1.285 1.328H6.857c-.71 0-1.286-.594-1.286-1.328V9.428zm-3.214 4.286c-.682 1.03-1.916 1.714-3.214 1.714s-2.533-.684-3.214-1.714zm-6.027-3.428c-1.007 0-1.87.712-2.009 1.714h1.188c.12-.386.408-.707.821-.707s.683.322.804.707h1.205c-.138-1.002-1.001-1.714-2.009-1.714m5.625 0c-1.007 0-1.87.712-2.009 1.714h1.206c.12-.386.39-.707.803-.707s.683.322.804.707h1.205c-.139-1.002-1.001-1.714-2.009-1.714m2.33-4.715c.71 0 1.286.595 1.286 1.329v1.243H5.571V6.9c0-.734.576-1.329 1.286-1.329z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.1a62fb4871eb10191ea4cfb84020b96a.svg";
export { ForwardRef as ReactComponent };